"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LOCAL_STORAGE_KEY = void 0;

var _react = require("react");

var _utils = require("../lib/utils");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LOCAL_STORAGE_KEY = 'globalCommentsViewAll';
exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;

var useGlobalCommentsToggle = function useGlobalCommentsToggle(annotationsMultiPageEnabled) {
  var _useState = (0, _react.useState)(function () {
    var cachedGlobalCommentsViewAll = (0, _utils.loadFromLocalStorage)(LOCAL_STORAGE_KEY); // default to true if value has not been set.

    if (typeof cachedGlobalCommentsViewAll === 'undefined') {
      (0, _utils.saveToLocalStorage)(LOCAL_STORAGE_KEY, true);
      cachedGlobalCommentsViewAll = true;
    }

    return cachedGlobalCommentsViewAll || annotationsMultiPageEnabled;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setToggle = _useState2[1];

  var onToggle = (0, _react.useCallback)(function (newActiveState) {
    (0, _utils.saveToLocalStorage)(LOCAL_STORAGE_KEY, newActiveState);
    setToggle(newActiveState);
  }, [setToggle]);
  (0, _react.useEffect)(function () {
    if (annotationsMultiPageEnabled) {
      onToggle(true);
    }
  }, [annotationsMultiPageEnabled, onToggle]);
  return (0, _react.useMemo)(function () {
    return {
      isActive: isActive,
      onToggle: onToggle
    };
  }, [isActive, onToggle]);
};

var _default = useGlobalCommentsToggle;
exports.default = _default;